export default function getAvatarPadding(colorCode: string) {
  if (!colorCode) {
    return "px-4 pl-5";
  }
  return "px-4 pl-0";
}